const InfoRounded = () => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M6.66667 0C2.98667 0 0 2.98667 0 6.66667C0 10.3467 2.98667 13.3333 6.66667 13.3333C10.3467 13.3333 13.3333 10.3467 13.3333 6.66667C13.3333 2.98667 10.3467 0 6.66667 0ZM6.66667 10C6.3 10 6 9.7 6 9.33333V6.66667C6 6.3 6.3 6 6.66667 6C7.03333 6 7.33333 6.3 7.33333 6.66667V9.33333C7.33333 9.7 7.03333 10 6.66667 10ZM7.33333 4.66667H6V3.33333H7.33333V4.66667Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default InfoRounded;
